import React from 'react';
import ReactDOM from 'react-dom/client';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';


import { Home, Product, Products, AboutPage, ContactPage, Cart, Login, Register, 
  Checkout, PageNotFound, CSCenterPage, FaqPage, OrderList, CatProducts, SuccessOrder, ChangePassword} from "./pages";
import {Admin,AdminLogin,Orderlist,FinishOrderlist,PendingMessage,AddUser,AddProducts} from './admin';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<Products />} />
        <Route path="/productCategory" element={<CatProducts />} />
        <Route path="/product/:productId/:categoryId" element={<Product />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/product/*" element={<PageNotFound />} />
        <Route path='/cscenter' element={<CSCenterPage />}/>
        <Route path='/faq' element={<FaqPage/>} />
        <Route path='/orderlist' element={< OrderList />}/>
        <Route path='/successPayment' element={< SuccessOrder />}/>
        <Route path='/admin' element={< Admin />}/>
        <Route path='/adminLogin' element={< AdminLogin />}/>
        <Route path='/admin/orderlist/:branchID' element={<Orderlist/>} />
        <Route path='/admin/finishOrderlist' element={<FinishOrderlist/>}/>
        <Route path='/admin/pendingMessage/:branchID' element={<PendingMessage  />}/>
        <Route path='/admin/addUser' element={ <AddUser/>}/>
        <Route path='/admin/addProducts' element={ <AddProducts/>}/>
        <Route path='/ChangePassword' element={< ChangePassword />} />
      </Routes>
    </Provider>
  </BrowserRouter>
);